// extracted by mini-css-extract-plugin
module.exports = {"link":"global_link__Ob-I9"};